import classnames from "classnames";
import { ReactNode, PropsWithChildren } from "react";

import { useMobile } from "@krea/customer-features/hooks";
import Container from "@krea/customer-features/shared-components/container";
import twMerge from "@krea/customer-features/utils/tailwind-utils";

interface IBidsListContainer {
  title: string;
  sort: ReactNode;
  htmlDesktop: ReactNode;
  htmlMobile: ReactNode;
  className?: string;
}

const BidsListContainer = ({
  title,
  sort,
  children,
  htmlDesktop,
  htmlMobile,
  className,
}: PropsWithChildren<IBidsListContainer>) => {
  const isMobile = useMobile();

  return (
    <div className={twMerge("tw-pb-7 tw-py-0", className)}>
      <div className={classnames("tw-mb-7 tw-py-0")}>
        <Container>
          <div className="tw-flex tw-items-center tw-justify-between tw-rounded-md tw-border tw-border-primary-300 tw-bg-primary-150 tw-p-4">
            <h5 className="tw-mb-1">{title}</h5>

            {sort && <div>{sort}</div>}
          </div>
        </Container>
      </div>

      <Container>
        {children}
        {!isMobile ? htmlDesktop : htmlMobile}
      </Container>
    </div>
  );
};

export default BidsListContainer;
